import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';
import { HiOutlineQuestionMarkCircle, HiOutlineCalendar, HiOutlineCreditCard, HiOutlineEmojiHappy, HiOutlineSupport } from 'react-icons/hi';

function HelpSupport() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    const helpSections = [
        {
            icon: <HiOutlineCalendar size={24} />,
            title: "Booking & Scheduling",
            content: "Booking is simple and convenient. We offer flexible scheduling to fit your lifestyle. Due to our fast 2-hour response time, cancellations are not available, but rescheduling is always an option."
        },
        {
            icon: <HiOutlineCreditCard size={24} />,
            title: "Payments",
            content: "We accept credit/debit cards, bank transfers, and digital wallets. All payments are secured with industry-standard encryption for your peace of mind."
        },
        {
            icon: <HiOutlineEmojiHappy size={24} />,
            title: "Satisfaction Guarantee",
            content: "Your satisfaction is our priority. If you're not happy, contact us within 24 hours. We'll review and make it right immediately."
        }
    ];

    return (
        <div className="bg-white min-h-screen">
            <HomeNav />
            
            {/* Help Hero */}
            <section className="pt-40 pb-20 bg-secondary relative overflow-hidden text-center">
                <div className="container-custom relative z-10 mx-auto max-w-2xl px-4">
                    <span className="text-primary font-black uppercase tracking-[0.3em] text-xs">Support Center</span>
                    <h1 className="text-5xl md:text-6xl font-heading font-black text-foreground mt-4">
                        How can we <span className="text-primary italic">help you?</span>
                    </h1>
                    <p className="text-muted-foreground text-lg mt-6 leading-relaxed">
                        Find answers to common questions and learn how we ensure your AstraClean experience is nothing short of perfect.
                    </p>
                </div>
            </section>

            <section className="py-24">
                <div className="container-custom">
                    <div className="max-w-4xl mx-auto space-y-12">
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {helpSections.map((section, i) => (
                                <div key={i} className="card-premium p-8 space-y-6 hover:translate-y-[-8px] transition-all">
                                    <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
                                        {section.icon}
                                    </div>
                                    <h3 className="text-xl font-bold">{section.title}</h3>
                                    <p className="text-muted-foreground text-sm leading-relaxed font-medium">
                                        {section.content}
                                    </p>
                                </div>
                            ))}
                        </div>

                        {/* Contact Support CTA */}
                        <div className="p-12 rounded-[3rem] bg-black text-white relative overflow-hidden group">
                            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                                <div className="space-y-4 text-center md:text-left">
                                    <h2 className="text-3xl font-heading font-black">Still have <span className="text-primary italic">Inquiries?</span></h2>
                                    <p className="text-gray-400 max-w-md font-medium">Our dedicated premium support team is available 24/7 to assist with your custom needs.</p>
                                </div>
                                <button className="btn-primary !px-12 !py-5 uppercase tracking-widest text-xs font-black flex items-center gap-3">
                                    <HiOutlineSupport size={20} />
                                    Speak with us
                                </button>
                            </div>
                            {/* Decorative background circle */}
                            <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full translate-x-1/2 -translate-y-1/3 blur-3xl group-hover:bg-primary/20 transition-all duration-700"></div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default HelpSupport;

